<script>
    import { goto } from '@roxi/routify';
    import { token } from './user/user.state.svelte.js';
    import Spinner from '../components/spinner.svelte';

    const redirect = $goto;

    $effect(() => {
        if (token.access_token) {
            redirect('/dashboard', {}, { replaceState: true });
        } else {
            redirect('/login', {}, { replaceState: true });
        }
    });
</script>

<!-- A light loading indicator prevents a white flash while the redirect evaluates -->
<div class="d-flex justify-content-center align-items-center" style="min-height: 80vh;">
    <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden"><Spinner /></span>
    </div>
</div>